export const getAgentLanguagesUrl = (locationId?: string, agentId?: string) =>
  `/business/locations/${locationId}/agents/${agentId}/languages`;
